module.exports = __webpack_public_path__ + "img/card-ribbon-left-sm.fb20d22e.svg";